import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

const {PROCEDURE_15} = environment;

@Injectable({
  providedIn: 'root',
})
export class ProcedureService {

  constructor(private http: HttpClient) {
  }

  saveProcedureRequest(data: any): Observable<any> {
    return this.http.post(`${PROCEDURE_15}/ProcedureRequest`, data);
  }

  updateProcedureRequest(idRequest, data): Observable<any> {
    return this.http.put(`${PROCEDURE_15}/ProcedureRequest/${idRequest}`, data);
  }


  getCurrentProcedure(): Observable<any> {
    return this.http.get(
      `${PROCEDURE_15}/ProcedureRequest/GetCurrentProcedure`
    );
  }


  getAllByUser(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/ProcedureRequest/GetAllByUser`);
  }


  getFilterGetAllDashboard(data: any) {
    let API_URL = `${PROCEDURE_15}/ProcedureRequest/GetAll`;
    return this.http.post(API_URL, data);
  }


  getById(id: any): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/ProcedureRequest/${id}`);
  }


  putStatus(status: any) {
    const urlBase = PROCEDURE_15 + '/ProcedureRequest/UpdateProcedureStatus';
    return this.http.put(urlBase, status);
  }


  getPdfPreview(data): Observable<any> {
    return this.http.post(`${PROCEDURE_15}/ProcedureRequest/GenerateLicense`, data);
  }

}
